var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-box mb-4"},[_c('ImageEntity',{ref:"imageEntity",attrs:{"image":_vm.eventImage},on:{"onImageDelete":_vm.onDeleteClicked,"onGoBack":function($event){return _vm.goBack()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }